// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","Header":"App_Header__TQGAd","Scrolled":"App_Scrolled__70GZ+"};